import { gql } from '@apollo/client';
import { useFetchCallback } from './useFetchCallback';

const GET_MODELS_PORTFOLIO = gql`
  query GetModels {
    getModels {
      id
      fileAs
      name
      code
      legacyKey
      currency
      Targets {
        name
        percentage
        ID
      }
    }
  }
`;

const GET_MODELS_PORTFOLIO_BACKUP = gql`
  query getModelsBackup {
    getModelsBackup {
      id
      fileAs
      name
      code
      legacyKey
      currency
      Targets {
        name
        percentage
        ID
      }
    }
  }
`;

export const useGetModelsPortfolioWithFallback = () => {
  return useFetchCallback(GET_MODELS_PORTFOLIO, GET_MODELS_PORTFOLIO_BACKUP, {
    errorPolicy: 'all',
  });
};

//export default () => useQuery(GET_MODELS_PORTFOLIO, { errorPolicy: "all" });
